import { render, staticRenderFns } from "./HistoryListDetectionRequestLayout.vue?vue&type=template&id=99bf2946&scoped=true&"
import script from "./HistoryListDetectionRequestLayout.vue?vue&type=script&lang=js&"
export * from "./HistoryListDetectionRequestLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bf2946",
  null
  
)

export default component.exports